import logoImg from './logo.png';

const Logo = ({ isCollapsed = false, className = '' }: { isCollapsed?: boolean, className?: string }) => {
    return (
        <img
            src={logoImg}
            alt="Logo"
            className={className}
            style={{
                width: !isCollapsed ? '172px' : '50px',
                height: '50px',
                objectFit: 'contain',
                objectPosition: 'left center'
            }}
        />
    )
}

export default Logo;